/**
 * The Pro tools are always on (Tarek, 1 Nov 2026): the vector toolbox, the numbers and blend modes in
 * Properties, every effect and the timing fields in Animate. It was a switch per browser, built 15 Oct
 * for a Simple mode; these two answers are all that is left of it.
 */

/** For code outside React (tools, menus built once). */
export function proTools(): boolean {
  return true;
}

export function useProTools(): boolean {
  return true;
}
